import * as Tone from 'tone';
import LiveState from './LiveState';
export const Transport = Tone.Transport;
export const Master = LiveState.Master;
export function stop(_) {
    Tone.Transport.stop();
    Tone.Transport.cancel();
    for (const track of LiveState.tracks) {
        track.stop(0);
    }
}
export { Tone };
export function dispose() {
    Tone.Transport.cancel(0);
    Tone.Transport.stop();
    Tone.Transport.loop = false;
    Tone.Transport.bpm.value = 120;
    Tone.Transport.timeSignature = [4, 4];
    LiveState.dispose();
}
export { default as LiveState } from './LiveState';
export { default as Chain } from './Chain';
export { default as Clip } from './Clip';
export { default as ClipSlot } from './ClipSlot';
export { default as Envelope } from './Envelope';
export { default as GroupTrack } from './GroupTrack';
export { default as ReturnTrack } from './ReturnTrack';
export { default as Scene } from './Scene';
export { default as AudioEffectRack } from '../effects/audio/AudioEffectRack';
export { default as AutoFilter } from '../effects/audio/AutoFilter';
export { default as Compressor } from '../effects/audio/Compressor';
export { default as EQ3 } from '../effects/audio/EQ3';
export { default as Limiter } from '../effects/audio/Limiter';
export { default as Utility } from '../effects/audio/Utility';
export { default as MidiRandom } from '../effects/midi/MidiRandom';
export { default as DrumRack } from '../instruments/DrumRack';
export { default as InstrumentRack } from '../instruments/InstrumentRack';
export { default as Simpler } from '../instruments/Simpler';
export { default as MIDIClip } from '../midi/MIDIClip';
export { default as MIDITrack } from '../midi/MIDITrack';
console.log('%c * Live.js 0.2.0 * ', 'background: #000; color: #fff'); // eslint-disable-line no-console
//# sourceMappingURL=Live.js.map